// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__21E-l","image":"card_image__1bzva","inside":"card_inside__mbAXe","favorite":"card_favorite__19Ilw"};